import { useEffect } from "react"
import { useImmerReducer } from "use-immer"
import Axios from "axios"
import { DISCOVER_BY_GENRE } from "../helpers/config"

export const useGenreFetch = (id) => {
  const initialState = {
    movies: [
      {
        adult: "",
        backdrop_path: "",
        genre_ids: [],
        id: "",
        original_language: "",
        original_title: "",
        overview: "",
        popularity: "",
        poster_path: "",
        release_date: "",
        title: "",
        video: "",
        vote_average: "",
        vote_count: "",
      },
    ],
    isFetching: "",
    page: 1,
    loadMoreRequestCount: 0,
  }

  function OurReducer(draft, action) {
    switch (action.type) {
      case "loadMovies":
        draft.movies = action.data
        return
      case "movieFetchingReqStart":
        draft.isFetching = true
        return
      case "movieFetchingFinish":
        draft.isFetching = false
        return
      case "loadMoreMovies":
        draft.movies = draft.movies.concat(action.data)
        return
      case "loadMore":
        draft.page = draft.page + 1
        return
      default:
        console.log("Do nothing")
    }
  }

  const [state, dispatch] = useImmerReducer(OurReducer, initialState)

  const fetchMoviesByGenre = async (ourRequest) => {
    try {
      const response = await Axios.get(`${DISCOVER_BY_GENRE}${id}&page=${state.page}`, {
        cancelToken: ourRequest.token,
      })
      if (response.data && state.page > 1) {
        dispatch({ type: "loadMoreMovies", data: response.data.results })
      } else {
        dispatch({ type: "loadMovies", data: response.data.results })
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    const ourRequest = Axios.CancelToken.source()
    fetchMoviesByGenre(ourRequest)

    return () => {
      ourRequest.cancel()
    }
    // eslint-disable-next-line
  }, [state.page, id])

  const movies = state.movies

  return [movies, dispatch]
}
